<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @doClear="initFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emMaMaintenanceWoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" editDisable
                                      with-custom-row-actions-first-column>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="userSecret"
                                                   custom-label="开始执行"
                                                   show-name
                                                   v-show="!judgeRouterStatus"
                                                   :disabled="isButtonDisabled(customRowScope.row)"
                                                   confirm-text="工单实际开始时间将被记录，确定要开始执行工单吗？"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="updateWorkOrderActualStartTime(customRowScope.row)">
                                        </em-button>
                                        <em-button type="task"
                                                   custom-label="任务"
                                                   show-name
                                                   :disabled="!isButtonDisabled(customRowScope.row)"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                                        </em-button>

                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-window-close"
                                               :disabled="actionDisabledDel('select')"
                                               custom-label="删除设备保养工单"
                                               :showName="true"
                                               v-show="judgeRouterStatus"
                                               confirm-text="确定要删除勾选的工单吗？"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="deleteWorkOrder()">
                                    </em-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="actionDisabled('selectOne')"
                                        show-name
                                        custom-label="上传附件报告"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
    </div>
</template>
<script>
// Author thq
// Date 2024-03-28 10:48:22
import emCommonListMixin from "@/mixin/em/common/list";
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";

export default {
    name: "emMaMaintenanceWoWorkflowListView",
    components: {MultiAttachment, ReBModal},
    mixins: [emCommonListMixin, emWorkflowListMixin, emCommonApiMixin, emTableCheckedMixin],
    data() {
        return {
            attachmentIds: '',
            saveAttachmentLoading: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        judgeRouterStatus() {
            return !(this.$_emWorkflowListMixin_pathType === "todo" || this.$_emWorkflowListMixin_pathType === "wait");
        },
    },
    methods: {
        // submitAttachmentChange() {
        //     this.saveAttachmentLoading = true;
        //     let api = process.env.VUE_APP_EM_MAINTENANCE_URL + "/" + this.modelName + "/upload/attachment";
        //     this.$_emApiMixin_put(api, {
        //         ids: this.$store.state[this.modelName].checkedItems,
        //         attachment: this.attachmentIds === undefined ? "" : this.attachmentIds
        //     }).then(() => {
        //         this.$message.success("保存成功");
        //         this.$refs.emListFilter.doQuery();
        //     }).finally(() => this.saveAttachmentLoading = false);
        // },
        submitAttachmentChange() {
            this.saveAttachmentLoading = true;
            let api = process.env.VUE_APP_EM_MAINTENANCE_URL + "/" + this.modelName + "/upload/attachment";

            // 判断 attachment 是否为空或者 undefined
            if (!this.attachmentIds) {
                // 如果 attachment 为空或者 undefined，弹出确认提示
                this.$confirm('没有选择上传附件，此操作提交将清空现有附件列表，是否继续？', '提示', {
                    confirmButtonText: '是(YES)',
                    cancelButtonText: '否(NO)',
                    type: 'warning'
                }).then(() => {
                    // 确认提交后执行上传操作
                    this.uploadAttachment(api);
                }).catch(() => {
                    // 取消提交，清除 loading 状态
                    this.saveAttachmentLoading = false;
                    this.$message.info("已取消提交动作");
                });
            } else {
                // 如果 attachment 不为空，直接执行上传操作
                this.uploadAttachment(api);
            }
        },
        // 提取上传操作为单独的方法
        uploadAttachment(api) {
            this.$_emApiMixin_put(api, {
                ids: this.$store.state[this.modelName].checkedItems,
                attachment: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                // 上传成功后的操作
                this.$message.success("附件上传成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },

        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        openAttachmentModal() {
            this.attachmentIds = this.$store.state[this.modelName].rows.filter(row => this.$store.state[this.modelName].checkedItems.indexOf(row.id) !== -1)[0].attachments;
            this.$refs.uploadAttachment.showModal();
        },
        actionDisabledDel(type) {

            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        deleteWorkOrder() {
            let self = this;
            if (self.selectIds) {
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/deleteWorkOrder?ids=${self.selectIds}`
                self.$_emApiMixin_post(url, {})
                    .then(request => {
                        if (request.status === 200) {
                            //console.log(request)
                            self.$message({
                                message: "删除成功，" + request.data,
                                type: "success",
                            });
                            self.$refs["emListFilter"].doQuery()
                        } else {
                            self.$message({
                                message: "删除失败",
                                type: "error",
                            });
                        }

                    })
            }
        },
        isButtonDisabled(row) {
            // 处理按钮的禁用状态的方法
            return row.actualStartDate !== null && row.actualStartDate !== undefined;
        },
        updateWorkOrderActualStartTime(row) {
            //console.log(row)
            if (row.actualStartDate !== null && row.actualStartDate !== undefined) {
                this.$message({
                    message: "工单已执行，实际开始时间已记录，不可再次执行！",
                    type: "warning",
                });
                return;
            }
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateWorkOrderActualStartTime?id=${row.id}`
            this.$_emApiMixin_post(url, {})
                .then(request => {
                    if (request.status === 200) {
                        //console.log(request)
                        this.$message({
                            message: "实际开始时间已变更，工单执行中",
                            type: "success",
                        });
                        this.$refs["emListFilter"].doQuery()
                    } else {
                        this.$message({
                            message: "执行失败",
                            type: "error",
                        });
                    }

                })
        },
        initFilter() {
            //清除设备档案跳转绑定的查询条件，清除按钮无法清空的问题
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('emArchBasicDataCodeFilter', null);
        }

    }
};
</script>